import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-follow-admin',
    templateUrl: './follow-admin.component.svg',
    styleUrls: ['./follow-admin.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FollowAdminComponent {}
